import { Navigate, type RouteObject } from "react-router-dom";

import { DeviceDetailPage } from "./pages/DeviceDetailPage.js";
import { DeviceFormPage } from "./pages/DeviceFormPage.js";
import { DeviceListPage } from "./pages/DeviceListPage.js";
import { AccountPage } from "./pages/AccountPage.js";
import { AlertsPage } from "./pages/AlertsPage.js";
import { ConnectorsPage } from "./pages/ConnectorsPage.js";
import { OrganizationsPage } from "./pages/OrganizationsPage.js";
import { PlatformPage } from "./pages/PlatformPage.js";
import { UsersPage } from "./pages/UsersPage.js";

/**
 * The signed-in route table, as data rather than JSX so the matcher can be
 * tested directly.
 *
 * Worth the indirection because of how these fail: "/devices/new" with no
 * route of its own does not 404, it quietly matches "/devices/:id" and the
 * detail page asks the API for a device whose id is the string "new". That
 * shipped once. A missing route is not a visible absence, so it is pinned by
 * a test instead.
 */
export const protectedRoutes: RouteObject[] = [
  { path: "/", element: <DeviceListPage /> },
  // Ahead of "/devices/:id" so the literal segment is never read as an id.
  // The matcher ranks static above dynamic whatever the order here, but the
  // two sitting together is what makes that legible.
  { path: "/devices/new", element: <DeviceFormPage /> },
  { path: "/devices/:id", element: <DeviceDetailPage /> },
  { path: "/devices/:id/edit", element: <DeviceFormPage /> },
  { path: "/alerts", element: <AlertsPage /> },
  { path: "/connectors", element: <ConnectorsPage /> },
  { path: "/organizations", element: <OrganizationsPage /> },
  { path: "/platform", element: <PlatformPage /> },
  { path: "/users", element: <UsersPage /> },
  { path: "/account/password", element: <AccountPage /> },
  { path: "*", element: <Navigate to="/" replace /> },
];
